import React from 'react';
import styles from './AddButton.module.scss';

type AddButtonProps = {
    onClick?: () => void;
    label?: string;
    disabled?: boolean;
    className?: string;
    title?: string;
    children?: React.ReactNode;
    withContainer?: boolean;
};

export const AddButton: React.FC<AddButtonProps> = ({ 
    onClick, 
    label = 'Add', 
    disabled, 
    className = '', 
    title, 
    children,
    withContainer = false 
}) => {
    const button = (
        <button
            type="button"
            className={`${styles.addButton} ${className}`}
            onClick={onClick}
            disabled={disabled}
            title={title || label}
        >
            {children ?? label}
        </button>
    );

    if (withContainer) {
        return (
            <div className={styles.addButtonContainer}>
                {button}
            </div>
        );
    }

    return button;
};

export default AddButton;


